module.exports = __webpack_public_path__ + "static/mission-img-4-61432011f10cb135e8a1967e7caf4902.jpg";